/**
 * Reads the suggestions FeatureCollection (Points in EPSG:3857, best first) into plain objects.
 * @param {Object} collection
 * @returns {Array<{id: string, rank: number, similarity: number, coordinate: number[],
 * bbox: number[]|null}>}
 */
export const parseSuggestions = collection =>
	(collection?.features ?? [])
		.filter(feature => feature?.geometry?.type === 'Point')
		.map((feature, index) => {
			const { similarity, rank, bbox } = feature.properties ?? {};
			const position = Number.isFinite(rank) ? rank : index + 1;
			return {
				id: String(position),
				rank: position,
				similarity: Number(similarity) || 0,
				coordinate: feature.geometry.coordinates,
				bbox: Array.isArray(bbox) && bbox.length === 4 ? bbox : null,
			};
		})
		.sort((a, b) => a.rank - b.rank);
